import { defineComponent, ref, Ref, computed, onMounted, onUnmounted } from "vue";
import context from '@truckdown/components-systems';

const messageEventName = 'show-message';

interface IEventParams {
    message: string,
    messageType: string,
    dismissable: boolean,
    autoDismiss: boolean
}

interface IData {
    message: Ref<string>,
    messageType: Ref<string>,
    dismissable: Ref<boolean>,
    autoDismiss: Ref<boolean>,
    dismissed: Ref<boolean>
}

const getData = function () {
    return {
        message: ref<string>(''),
        messageType: ref<string>(''),
        dismissable: ref<boolean>(true),
        autoDismiss: ref<boolean>(true),
        dismissed: ref<boolean>(false)
    } as IData;
};

const getComputed = function (data: IData) {
    return {
        isVisible: computed(() => {
            return data.message.value.length > 0 && !data.dismissed.value;
        }),
        classes: computed(() => {
            let classes = ['td-banner', 'status-message'];
            if (data.dismissable.value) {
                classes.push('dismissible');
            }
            if (data.messageType.value.length > 0) {
                classes.push(data.messageType.value);
            }
            return classes;
        })
    }
}

const getMethods = function (data: IData) {
    return {
        dismiss: function () {
            data.dismissed.value = true;
        }
    }
}

export default defineComponent({
    props: {
    },
    setup: function () {
        var data = getData();
        var computed = getComputed(data);
        var methods = getMethods(data);

        let showMessage = function (params: IEventParams) {
            data.message.value = params.message;
            data.messageType.value = params.messageType;
            data.dismissable.value = params.dismissable;
            data.dismissed.value = false;

            setTimeout(() => {
                data.dismissed.value = params.autoDismiss;
            }, 5000);
        };

        onMounted(() => {
            context.events.on(messageEventName, showMessage);
        })

        onUnmounted(() => {
            context.events.off(messageEventName, showMessage);
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});